// extracted by mini-css-extract-plugin
export var cardSelected = "_g2-2";
export var image = "_g2-1";
export var table = "_g2-0";